jQuery(function ( $ ) {

	var is_mobile = check_mobile();

	function check_mobile() {
		return window.matchMedia('all and (max-width: 1000px)').matches;
	}

	$(window).resize(function () {
		is_mobile = check_mobile();
	});

	jQuery('.slider').slider({
		interval   : 5000				// Интервал смены слайда
		, speed    : 300 				// Скорость смены слайдов
		, countView: 2 				// количество видимых блоков
		, classItm : '.slider_item'	// класс отдельного слайда
		, automove : true             //автоматическое пролистывание
	});

	jQuery('.all-cat-slider').slider({
		interval   : 5000				// Интервал смены слайда
		, speed    : 300 				// Скорость смены слайдов
		, countView: 2 				// количество видимых блоков
		, classItm : '.all-cat-slider__itm'	// класс отдельного слайда
		, automove : false             //автоматическое пролистывание
		, onpage   : 3
	});

	jQuery('.gallery').slider({
		interval   : 5000				// Интервал смены слайда
		, speed    : 300 				// Скорость смены слайдов
		, countView: 2 				// количество видимых блоков
		, classItm : '.gallery_itm'	// класс отдельного слайда
		, automove : false             //автоматическое пролистывание
		, loop     : true
	});

	jQuery('.events_block__first_line__white_block').school_list({});

	jQuery('.events_block__second_line').school_list({});

	jQuery('.js-spoiler').fields_block({
		list_itm         : '.fields_block__itm',
		max_count_on_line: 3,
		elem_name        : 'направлени'
	});

	jQuery('.project_list').fields_block({
		list_itm         : '.fields_block__itm',
		max_count_on_line: 3,
		elem_name        : 'проект'
	});


	jQuery('.news_block').news_list({
		max_count_on_line: 3
	});

	jQuery('.video_block').news_list({
		max_count_on_line: 3
	});

	jQuery('.photo_block').news_list({
		max_count_on_line: 3
	});

	jQuery('.bottom_slider_block').news_list({
		max_count_on_line: $('.bottom_slider_block').attr('data-count'),
		has_column: false
	});


	$(document).on('click', '.has_sub_link, .has_sub_link__arrow', function () {
		var parent      = $(this).parent('.structure_top_itm'),
		    hidden_text = parent.find('.hidden_text'),
		    arrow       = parent.find('.blue_arrow');

		hidden_text.slideToggle(200);
		arrow.toggleClass('rotate');
		parent.toggleClass('active');

		return !arrow.hasClass('rotate');   //второй клик по ссылке должен быть переходом

	});

	$(document).on('click','.modal-link',function (  ) {
		var id = $(this).attr('data-modal'),
		    modal = $('#'+id);

		if(modal){
			modal.addClass('show');
		}

	});

	$(document).on('click','.modal-fade,.modal-close',function (  ) {
		var modal =  $(this).parents('.modal-container');

		if(modal){
			modal.removeClass('show');
		}

	});

	//при нажатии на форму открывается клавиатура, поэтому нужно смещение
	$('.header_search_box_mobile__input').on('focus', function () {
		var dn = $(this).offset().top;
		$('.head-menu-wrap').animate({scrollTop: dn + 150}, 100);
	});

	// Если метод определен, то применим его
	if( typeof $().rusHyphenate === 'function' ) {
		$('.js-hyphenate').rusHyphenate();
	}


	$(document).on('click', '.js-tab-title', function () {

		var num = $(this).index();

		$('.js-tab-main').hide();

		$('.js-tab-title').removeClass('active').eq(num).addClass('active');
		$(this).closest('.js-tabs').find('.js-tab-main').eq(num).show();
	});


	$(document).mousedown(function ( e ) {
		var parent    = $(".all-cat-list.active").parent();
		var container = $(".all-cat-list.active");

		if( parent.has(e.target).length === 0 ) {
			container.hide();
			container.removeClass('active');
		}

	});

	$('.news_block__cat_list__all_cat').click(function () {
		var parent = $(this).parent(),
		    list   = parent.find('.all-cat-list');

		list.fadeToggle(300);
		list.toggleClass('active');
	});

	/*************************************************************************/
	/***************************** SPOILER ***********************************/
	$(document).on('click', '.spoiler_item__top', function () {
		var parent      = $(this).parent(),
		    sourceBlock = parent.find('.hidden_text');

		parent.toggleClass('active');
		sourceBlock.slideToggle(200);
	});

	/*************************************************************************/
	/******************************* MENU ************************************/
	$('.js-slide-menu > ul > li').on('mouseenter', function () {
		if( is_mobile ) return;

		var sub_block = $(this).find('ul');

		if( sub_block.length > 0 ) {
			$(this).addClass('active');
			sub_block.stop().show(200);
		}
	}).on('mouseleave', function () {
		$(this).removeClass('active');
		if( is_mobile ) return;

		$(this).find('ul').stop().hide(200, function () {
			$(this).removeClass('active');
		});
	});


	// открыть меню в мобильной версии
	$('.js-show-menu').click(function () {
		$(this).toggleClass('active');
		$(this).find('.gamburger').toggleClass('active');
		$('html, body').toggleClass('hide');
		$('.js-mobile-menu').toggleClass('show');
	});

	function show_sub_menu_mobile( self ) {
		$('.js-slide-menu > ul ul').slideUp(200);
		$('.js-slide-menu a').removeClass('canlink');
		self.siblings('ul').slideDown(200);
		self.addClass('canlink');
	}

	function is_submobile( self ) {
		if( !is_mobile ) {
			return false;
		}

		if( self.siblings('ul').length === 0 ) {
			return false;
		}

		if( self.hasClass('canlink') ) {
			return false;
		}

		return true;
	}


	$('.js-slide-menu > ul > li > a').click(function () {
		if( is_submobile($(this)) ) {
			show_sub_menu_mobile($(this));

			return false;
		}
	});

	/****       Стилизация таблиц       ****/
	$('.style-table, .js-content table').each(function () {
		$(this).wrap('<div class="style-table-wrap"></div>');
	});

	/*************************************************************************/
	/********************* RADIOBUTTON STYLING *******************************/

	/*************************************************************************/
	init_radio_style();

	function init_radio_style() {
		$('input.styling_radio').each(function () {
			if( !$(this).parent().is('.radio_wrap') ) {
				$(this).wrap('<span class="radio_wrap"></span>');
			}


			if( $(this).prop('checked') ) {
				$(this).parent('.radio_wrap').addClass('checked');
			} else {
				$(this).parent('.radio_wrap').removeClass('checked');
			}

		});
	}

	$(document).on('mousedown', '.radio_wrap', function () {
		$(this).children('input.styling_radio').click();
	});

	$(document).on('change', 'input.styling_radio', function () {
		var name = $(this).attr('name');
		$('input.styling_radio[name="' + name + '"]').parent('.radio_wrap').removeClass('checked');
		$(this).parent('.radio_wrap').addClass('checked');
	});

	$(document).on('focus', 'input.styling_radio', function () {
		$(this).parent('.radio_wrap').addClass('focus');
	});

	$(document).on('blur', 'input.styling_radio', function () {
		$(this).parent('.radio_wrap').removeClass('focus');
	});


	/*************************************************************************/
	/********************* CHECKBOX STYLING *******************************/

	/*************************************************************************/
	init_checkbox_style();

	function init_checkbox_style() {
		$('input.styling_checkbox').each(function () {
			if( !$(this).parent().is('.checkbox_wrap') ) {
				$(this).wrap('<span class="checkbox_wrap"></span>');
			}


			if( $(this).prop('checked') ) {
				$(this).parent('.checkbox_wrap').addClass('checked');
			} else {
				$(this).parent('.checkbox_wrap').removeClass('checked');
			}

		});
	}

	$(document).on('mousedown', '.checkbox_wrap', function () {
		$(this).children('input.styling_checkbox').click();
	});

	$(document).on('change', 'input.styling_checkbox', function () {
		$(this).parent('.checkbox_wrap').toggleClass('checked');
	});

	$(document).on('focus', 'input.styling_checkbox', function () {
		$(this).parent('.checkbox_wrap').addClass('focus');
	});

	$(document).on('blur', 'input.styling_checkbox', function () {
		$(this).parent('.checkbox_wrap').removeClass('focus');
	});


	//***       visual-imparied     ***//
	var body = $('body');
	$('.js-set-color.black').on('click', function () {
		body.addClass('black');
		$('.blind-settings__color-itm').removeClass('active');
		$(this).addClass('active');
	});

	$('.js-set-color.white').on('click', function () {
		body.removeClass('black');
		$('.blind-settings__color-itm').removeClass('active');
		$(this).addClass('active');
	});


	$('.js-set-fz').on('click', function () {
		$('.blind-settings__font-size-itm').removeClass('active');
		$(this).addClass('active');

		if( $(this).hasClass('ltl') ) {
			body.addClass('fs-ltl');
			body.removeClass('fs-mid fs-big');
			return false;
		}

		if( $(this).hasClass('mid') ) {
			body.addClass('fs-mid');
			body.removeClass('fs-ltl fs-big');
			return false;
		}

		if( $(this).hasClass('big') ) {
			body.addClass('fs-big');
			body.removeClass('fs-ltl fs-mid');
		}
	});

	$(document).on('click', 'a', function () {
		var site_url = document.location.host,
		    link_url = $(this).attr('href');

		if( link_url.indexOf('http') < 0 ) {
			return true;
		}

		if( link_url.indexOf(site_url) >= 0 ) {
			return true;
		}

		window.open(link_url);
		return false;
	})


	//***       /visual-imparied     ***//
});